import React, { useEffect } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import { HiPhone } from "react-icons/hi";

const Footer = () => {
  /* ================= STYLES ================= */

  const styles = {
    footer: {
      background: "#006664",
      color: "#fff",
      fontFamily:
        '"Roboto", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif'
    },

    content: {
      display: "flex",
      justifyContent: "center",
      padding: "50px 90px"
    },

    contactBox: {
      maxWidth: "420px",
      margin: "0 auto",
      textAlign: "left"
    },

    h3: {
      fontSize: "20px",
      fontWeight: 700,
      textAlign: "center",
      letterSpacing: "1px",
      textTransform: "uppercase"
    },

    divider: {
      height: "3px",
      width: "70px",
      margin: "12px auto 25px",
      background: "linear-gradient(90deg,#00e5ff,#ffffff)",
      borderRadius: "3px"
    },

    h4: {
      color: "#e0f7fa",
      marginBottom: "20px",
      fontWeight: 600,
      textAlign: "center"
    },

    contactRow: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      marginBottom: "32px",
      fontSize: "14px"
    },

    icon: {
      minWidth: "18px",
      color: "#00e5ff",
      fontSize: "16px",
      marginTop: "3px"
    },

    emptyIcon: {
      minWidth: "18px"
    },

    contactText: {
      lineHeight: "1.6"
    },

    bottom: {
      background: "#074039",
      padding: "35px 20px",
      textAlign: "center"
    },

    nav: {
      marginTop: "20px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "25px",
      marginBottom: "18px"
    },

    navLink: {
      color: "#e0f7fa",
      textDecoration: "none",
      fontWeight: 500
    },

    socialRow: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      marginBottom: "15px"
    },

    socialIcon: {
      width: "44px",
      height: "44px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.12)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.25)",
      cursor: "pointer",
      transition: "0.3s"
    },

    copyright: {
      fontSize: "13px",
      color: "#b2dfdb"
    },
    text: {
      // paddingBottom: "20px"
    }
  };

  /* ================= JSX ================= */

  return (
    <footer style={styles.footer}>
      {/* CONTACT */}


      {/* BOTTOM */}
      <div style={styles.bottom}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
          color: "#b2dfdb",
          marginBottom: "15px"
        }}>
          <a href="/flats-for-sale-in-trichy/" style={{ textDecoration: "none", color: "inherit" }}>Apartments for sale in Trichy</a><span>|</span>
          <a href="/3-bhk-flats-for-sale-in-srirangam-mitha-rangasthalam" style={{ textDecoration: "none", color: "inherit" }}>Flats for sale in Srirangam</a><span>|</span>
          <a href="/3bhk-flats-for-sale-in-thillainagar/mitha-amethyst" style={{ textDecoration: "none", color: "inherit" }}>Flats for sale in Thillai Nagar</a>
        </div>

        <div style={styles.nav}>
          <a href="/privacy-policy" style={styles.navLink}>Privacy Policy</a>
          <a href="/terms-of-use" style={styles.navLink}>Terms of Use</a>
          <a href="/contact" style={styles.navLink}>Contact us</a>
        </div>

        <div style={styles.socialRow}>
          <a target="blank" href="https://www.facebook.com/mitha.homes/" style={styles.socialIcon}><FaFacebookF /></a>
          <a target="blank" href="https://www.instagram.com/mithahomestrichy/" style={styles.socialIcon}><FaInstagram /></a>
          <a target="blank" href="https://www.youtube.com/@mithahomes5355" style={styles.socialIcon}><FaYoutube /></a>
        </div>

        <p style={styles.copyright}>
          © Mitha Construction & Development. All Rights Reserved.
        </p>
      </div>

      {/* ROBOTO FONT */}
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
        rel="stylesheet"
      />
    </footer>
  );
};

export default Footer;
